module.exports = __webpack_public_path__ + "assets/delete.009e68ec.svg";